import React from 'react'
import OpeLoader from '../utils/ope-loader'
import UploadActions from '../../actions/upload-actions'
import AdobeAnalytics from '../../utils/adobe-analytics'
import SelectorActions from '../../actions/selector-actions'
import PhotoorganiseActions from '../../actions/photoorganise-actions'
import OpeImagePhotoorganiser from '../../objects/opeimage/photoorganiser'
import createReactClass from 'create-react-class'



var SelectorGalleryItem = createReactClass({
    mounted: false,

	getInitialState: function () {
		return {thumbImageSrc: null};
	},

	loadImage: function () {
		var self = this;
		if (self.props.imageItem) {
			self.props.imageItem.getSrcWithFilter(300, self.props.orderItem.getImageFilters()).then(function (src) {
							if (self.mounted) {
									self.setState({thumbImageSrc: src});
							}
			})['catch'](function (err) {
				displayError(_("Cannot show photo. Please try deleting and uploading again. If it still doesn’t show, please contact us."), {imageId: self.props.imageItem.getId(), err: err});
			});
		}
	},
	componentWillReceiveProps: function () {
		//this.loadImage();
	},
	componentDidMount: function () {
        this.mounted = true;
		this.loadImage();
	},
	removeImage: function (event) {
		event.stopPropagation();

		var imageId = this.props.imageItem.getId();

		if (this.props.imageItem instanceof OpeImagePhotoorganiser) { //Photoorganiser image
			//Remove the mark that show the image has been imported into editor
			PhotoorganiseActions.toggleImageImported(imageId);
		}

		//Remove the order item
		SelectorActions.removeOrderItemsByImageId(imageId);

		//Remove the image from the image store
		UploadActions.removeImageFromStore(imageId);

	},
	viewLargeImage: function () {
		this.props.viewLargeCallback(this.props.imageItem.getId(), this.props.orderItem);
	},
	render: function() {

		if (this.state.thumbImageSrc) {
			return (
				<li className="ope-gallery__item large-2 medium-3 small-4 columns" data-tam="thumbnails" onClick={this.viewLargeImage} style={{backgroundImage: "url( " + this.state.thumbImageSrc + ")"}}>
					<div className="ope-gallery__item__delete" onClick={this.removeImage}>
						<span className="ope-icon ope-icon--delete-white"></span>
					</div>
				</li>
			);
		} else {
			return (
				<li className="ope-gallery__item large-2 medium-3 small-4 columns" data-tam="thumbnails">
					<OpeLoader />
				</li>
			);
		}
	},
    componentWillUnmount: function() {
        this.mounted = false;
    }
});

export default SelectorGalleryItem;
